<template>
  <div class="content__wrapper">
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-15 md-small-size-50 md-xsmall-size-100">
        <router-link :to="{ name: 'Building stock summary'}">
          <div class="card">
            <i class="ico ico_bati"/>
            <div class="md-title">Parc Bâti</div>
          </div>
        </router-link>
      </div>
      <div class="md-layout-item md-size-15 md-small-size-50 md-xsmall-size-100">
        <router-link :to="{ name: 'Scenarios'}">
          <div class="card">
            <i class="ico ico_scenario"/>
            <div class="md-title">Scénarios</div>
          </div>
        </router-link>
      </div>
      <div class="md-layout-item md-size-15 md-small-size-50 md-xsmall-size-100">
        <router-link :to="{ name: 'PPI'}">
          <div class="card">
            <i class="ico ico_bati"/>
            <div class="md-title">PPI</div>
          </div>
        </router-link>
      </div>
      <div class="md-layout-item md-size-15 md-small-size-50 md-xsmall-size-100">
        <router-link :to="{ name: 'Atypical'}">
          <div class="card">
            <i class="ico ico_actions_atypique"/>
            <div class="md-title">Actions atypiques</div>
          </div>
        </router-link>
      </div>
      <div class="md-layout-item md-size-15 md-small-size-50 md-xsmall-size-100">
        <router-link :to="{ name: 'Base d\'actions'}">
          <div class="card">
            <i class="ico ico_actions"/>
            <div class="md-title">Base d'actions</div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  created () {
    var app = this
    app.$store.dispatch('routing/update_title', "Planiss'Immo")
    app.$store.dispatch('routing/update_return_kwargs', null)
  }
}
</script>

<style lang="scss" scoped>
.card {
  background: darken(white, 4);
  border: 1px solid #eee;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue